import { logger } from './Logger.js';

export class StorySystem {
  constructor() {
    this.beats = [
      {
        id: 'first_guard_done',
        type: 'major',
        speaker: 'Dra. V',
        text: 'Sobreviviste tu primera guardia. No te relajes, esto apenas empieza.',
        trigger: (eco, adaptive, session) => eco.dailyGuards >= 1 || eco.guardsToday >= 1
      },
      {
        id: 'first_lethal',
        type: 'major',
        speaker: 'Dra. V',
        text: 'Ven a mi oficina. Hablemos de lo que pasó — y de lo que vas a leer esta noche.',
        trigger: (eco, adaptive, session) => session && session.lethals > 0
      },
      {
        id: 'first_correction',
        type: 'minor',
        speaker: 'Dra. V',
        text: 'Eso. Un residente que corrige es mejor que uno que nunca falla.',
        trigger: (eco, adaptive, session) => session && session.isCorrection === true // Need to pass this info
      },
      {
        id: 'first_mentor',
        type: 'minor',
        speaker: 'Dra. V',
        text: 'Tienes apoyo ahora. Aprovecha su experiencia.',
        trigger: (eco, adaptive, session) => Object.keys(eco.roster).length > 0
      },
      {
        id: 'level_5',
        type: 'major',
        speaker: 'Dra. V',
        text: 'Nivel 5. Ya no eres un residente novato. Actúa como tal.',
        trigger: (eco, adaptive, session) => eco.playerLevel >= 5
      },
      {
        id: 'level_10',
        type: 'major',
        speaker: 'Dra. V',
        text: 'Nivel 10. Empiezas a tener instinto clínico.',
        trigger: (eco, adaptive, session) => eco.playerLevel >= 10
      },
      {
        id: 'first_chain_survived',
        type: 'minor',
        speaker: 'Dra. V',
        text: 'Ese paciente de terapia intensiva está estable. Buen trabajo manejando el caso completo.',
        trigger: (eco, adaptive, session) => session && session.chainSurvived
      },
      {
        id: 'domain_50',
        type: 'major',
        speaker: 'Dra. V',
        text: 'Más de la mitad de dominio en una sala. Se nota que has estado estudiando.',
        trigger: (eco, adaptive, session) => {
           // We would need to calculate max domain here, but for now we can just check if any stat > 0.5
           // Adaptive handles stats, Economy stores them in caseHistory
           const domains = Object.keys(eco.caseHistory).filter(k => k.startsWith('__topic_'));
           for (let k of domains) {
              const stats = eco.caseHistory[k];
              if (stats && stats.total > 0 && (stats.correct / stats.total) >= 0.5 && stats.total >= 5) return true;
           }
           return false;
        }
      },
      {
        id: 'burnout_high',
        type: 'major',
        speaker: 'Dra. V',
        text: 'Ve a dormir. El hospital sigue aquí mañana. Tu mente necesita descansar.',
        trigger: (eco, adaptive, session) => eco.burnout > 70
      },
      {
        id: 'day_3',
        type: 'minor',
        speaker: 'Dra. V',
        text: 'Tercer día. ¿Ya te acostumbras al ritmo?',
        trigger: (eco, adaptive, session) => eco.dayNumber >= 3
      },
      {
        id: 'day_7',
        type: 'major',
        speaker: 'Dra. V',
        text: 'Una semana completa. Muchos se rinden antes. Sigue así.',
        trigger: (eco, adaptive, session) => eco.dayNumber >= 7
      },
      {
        id: 'day_15',
        type: 'major',
        speaker: 'Dra. V',
        text: 'Quince días. Has visto de todo, pero la medicina siempre te sorprende. No bajes la guardia.',
        trigger: (eco, adaptive, session) => eco.dayNumber >= 15
      }
    ];
  }

  /**
   * Checks if any new beats should be triggered
   * @param {Object} eco EconomySystem instance
   * @param {Object} adaptive AdaptiveSystem instance
   * @param {Object} sessionData Data from the current session (optional)
   * @returns {Array} Array of newly triggered beats
   */
  checkBeats(eco, adaptive, sessionData = null) {
    const triggered = [];
    
    for (const beat of this.beats) {
      if (!eco.storyBeatsSeen.includes(beat.id)) {
        try {
          if (beat.trigger(eco, adaptive, sessionData)) {
            eco.storyBeatsSeen.push(beat.id);
            triggered.push(beat);
            logger.info(`[StorySystem] Beat triggered: ${beat.id}`);
          }
        } catch (e) {
          logger.error(`[StorySystem] Error checking beat ${beat.id}:`, e);
        }
      }
    }
    
    return triggered;
  }
}
